export default __webpack_public_path__ + "static/media/151.6d9ce738.png";